<template>
    <div class="card ">
        <div class="right-header2">
            <div class="card-header">
                <div class="d-flex">
                    <h5 class="card-title flex-grow-1 mb-0">Tasks</h5>

                    <div class="cpreder">

                    </div>
                </div>
            </div>
        </div>
        <div class="card-body2">
            <div class="list-containerbox">
                <div class="listDetails" v-if="tasks">
                    <div class="order-task-right mb-3">
                        <span class="text-left mb-2 open-tasks-header">Open Tasks</span> <br>
                        <ul v-for="(task, index) in tasks.filter((x) => x.status === 0)" class="tasklistrow" :key="task.id">
                            <li>
                                <template v-if="compareString(task.title, 'Create Purchase Order') || compareString(task.title, 'Create PO on remaining items')">
                                    <template v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('add-purchase-order')">
                                        <a href="javascript:void(0);" @click="createPOFromSO(order, orderQuotes, setNewPurchaseOrder)">{{primaryTaskPrefix}} {{task.title}}</a>
                                    </template>
                                    <template v-else> {{primaryTaskPrefix}} {{task.title}}</template>
                                </template>
                                <template v-else-if="compareString(task.title, 'Send Sales Order to customer')">
                                    <a href="javascript:void(0);" @click="sendToCustomer()">{{primaryTaskPrefix}} {{task.title}}</a>
                                </template>
                                <template v-else-if="compareString(task.title, 'Receive artwork and send to vendor')">
                                    <a href="javascript:void(0);" @click="artworkSampleRequiredEvent()">{{primaryTaskPrefix}} {{task.title}}</a>
                                </template>
                                <template v-else-if="compareString(task.title, 'Send Purchase Order to vendor')">
                                    <a href="javascript:void(0);" @click="sendToVendor()">{{primaryTaskPrefix}} {{task.title}}</a>
                                </template>
                                <template v-else-if="compareString(task.title, 'Get a ready date and set a follow up date')">
                                    <a href="javascript:void(0);" @click="openGetAReadyDate(task, 'eta')">{{primaryTaskPrefix}} {{task.title}}</a>
                                </template>
                                <template v-else-if="compareString(task.title, 'Confirm ready date')">
                                    <a href="javascript:void(0);" @click="openGetAReadyDate(task, 'confirm')">{{primaryTaskPrefix}} {{task.title}}</a>
                                </template>
                                <template v-else-if="compareString(task.title, 'Get Shipping Schedule')">
                                    <a href="javascript:void(0);" @click="openGetAReadyDate(task, 'etd')">{{primaryTaskPrefix}} {{task.title}}</a>
                                </template>
                                <template v-else-if="compareString(task.title, 'Sent deposit to vendor')">
                                    <span class="col-2">{{task.title}}</span>
                                    <span class="col-2">Amount</span>
                                    <span class="col-6"><input type="text" v-on:keydown="checkDecimal($event, this)" v-model="order.deposit_sent_amount" placeholder="" class="form-control-sm"></span>
                                    <span class="col-2"><a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="depositSent(task)">Deposit Sent</a></span>
                                </template>
                                <template v-else-if="compareString(task.title, 'Factory to ship sample')">
                                    <span class="col-2">{{task.title}}</span>
                                    <span class="col-2">Tracking</span>
                                    <span class="col-6"><input type="text" v-model="order.sample_tracking_no" placeholder="" class="form-control-sm"></span>
                                    <span class="col-2"><a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="sampleShipped(task)">Sample shipped</a></span>
                                </template>
                                <template v-else-if="compareString(task.title, 'Check for Air Freight')">
                                    {{task.title}} <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="openCheckAirFreight(task)">{{task.title}}</a>
                                </template>
                                <template v-else> {{primaryTaskPrefix}} {{task.title}}</template>
                            </li>
                            <!--<li v-if="task.admins">
                                Assigned To:
                                <template v-for="(admin, adminIndex) in task.admins">
                                    <template v-if="adminIndex > 0">, </template>{{admin.name}}
                                </template>
                            </li>
                            <li v-if="task.priority">
                                Priority: {{task.priority.priority_name }}
                            </li>
                            <li>
                                Due Date : {{formatDate(task.due_date) }}
                            </li>-->
                        </ul>
                        <template v-if="taskType && taskType == 'po'">
                            <ul v-for="(task, index) in relatedTasks.filter((x) => x.status === 0)" class="tasklistrow" :key="task.id">
                                {{secondaryTaskPrefix}} {{task.title}}
                            </ul>
                        </template>
                        <template v-else>
                            <template v-for="(po) in relatedTasks.filter((x) => x.tasks)">
                                <ul v-for="(task, index) in po.tasks.filter((x) => x.status === 0)" class="tasklistrow" :key="task.id">
                                    {{secondaryTaskPrefix}} {{task.title}}
                                </ul>
                            </template>
                        </template>
                    </div>


                    <div class="order-task-right mb-0">
                        <span class="text-left mb-2 completed-tasks-header task-row"><span>Completed Tasks</span> <span class="taskcol">
                          <a v-if="!toggleCompletedTaskList" href="javascript:void(0);" @click="toggleCompletedTaskList=true" class="taskplus">+</a>
                          <a v-if="toggleCompletedTaskList" href="javascript:void(0);" @click="toggleCompletedTaskList=false" class="taskmn">-</a></span></span> <br>
                        <ul v-if="toggleCompletedTaskList" v-for="(task, index) in tasks.filter((x) => x.status === 1)" class="tasklistrow" :key="task.id">
                            <li>
                                <template v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin')">
                                    <a href="javascript:void(0)" @click="editTask(task)" title="Edit Task">
                                        {{primaryTaskPrefix}} {{ task.title }}
                                    </a>
                                </template>
                                <template v-else>
                                    {{primaryTaskPrefix}} {{ task.title }}
                                </template>:
                                <template v-if="compareString(task.title, 'Get Shipping Schedule')">
                                    ETD: {{formatDate(task.etd)}}, ETA: {{formatDate(task.eta)}},
                                </template>
                                {{ task.completed_at ? formatDate(task.completed_at) : formatDate(task.updated_at) }}
                            </li>
                            <li v-if="task.admins">
                                By:
                                <template v-for="(admin, adminIndex) in task.admins">
                                    <template v-if="adminIndex > 0">, </template>{{admin.name}}
                                </template>
                            </li>
                        </ul>


                      <template v-if="toggleCompletedTaskList">
                        <template v-if="taskType && taskType == 'po'">
                          <ul v-for="(task, index) in relatedTasks.filter((x) => x.status === 1)" class="tasklistrow" :key="task.id">
                            {{secondaryTaskPrefix}} {{task.title}}
                          </ul>
                        </template>
                        <template v-else>
                          <template v-for="(po) in relatedTasks.filter((x) => x.tasks)">
                            <ul v-for="(task, index) in po.tasks.filter((x) => x.status === 1)" class="tasklistrow" :key="task.id">
                              {{secondaryTaskPrefix}} {{task.title}}
                            </ul>
                          </template>
                        </template>
                      </template>

                    </div>

                </div>
                <div class="order-btnsec">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import axios from "axios";

export default {
    name: "OrderTask",
    props:['order', 'loading', 'taskType', 'bus', 'orderQuotes'],
    components: {},
    mounted() {
        //let self = this;
        this.primaryTaskPrefix = 'SO Task:';
        this.secondaryTaskPrefix = 'PO Task:';
        if(this.taskType && this.taskType == 'po') {
            this.primaryTaskPrefix = 'PO Task:';
            this.secondaryTaskPrefix = 'SO Task:';
        }
        this.bus.$on('triggerGetTasks', () => {
            this.getTasks();
        });
        /*$('#addTaskModal').on('hidden.bs.modal', function () {
            self.task = null;
        });*/
        this.syncLatestData();
        this.getTasks();
    },
    data() {
        return {
          tasks: [],
          relatedTasks: [],
          task: null,
          primaryTaskPrefix: '',
          secondaryTaskPrefix: '',
          toggleCompletedTaskList: false,
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setNewPurchaseOrder'
        ]),
        openCheckAirFreight(task){
            this.$emit('openCheckAirFreightEvent', task);
        },
        depositSent(task){
            this.$emit('depositSentEvent', task);
        },
        sampleShipped(task){
            this.$emit('sampleShippedEvent', task);
        },
        openGetAReadyDate(task, dateType = 'eta'){
            this.$emit('openGetAReadyDateEvent', {task: task, dateType: dateType});
        },
        editTask(task) {
            this.$emit('openTaskEditEvent', task);
        },
        sendToVendor() {
            this.$emit('sendPOToVendorEvent');
        },
        changeEditMode() {
            this.$emit('editModeEvent');
        },
        sendToCustomer(){
            this.$emit('sendToCustomerEvent');
        },
        artworkSampleRequiredEvent(){
            this.$emit('artworkSampleRequiredEvent');
        },
        getTasks() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let url = window.route('orders.tasks.index', {id: this.order.id});
            if(this.taskType && this.taskType == 'po') {
                url = window.route('po.tasks.index', {id: this.order.id});
            }

            return axios.get(url, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.tasks = _.cloneDeep(data.data);
                        this.relatedTasks = _.cloneDeep(data.tasks);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        syncLatestData(){

        }
    },
    computed: {

    },
    watch: {
        'order': {
            handler: function (after, before) {
                this.syncLatestData();
            }
        }
    },
}
</script>

<style scoped>

</style>
